<template>
  <div :class="{ 'has-back-button': currentStep > 1 }" class="signup-buttons">
    <ButtonTransparent v-if="currentStep > 1" :busy="isSubmitting" :icon="$icons.back" icon-to-left @click="goBack">
      {{ $t('signupButtons.back') }}
    </ButtonTransparent>
    <ButtonGreen :busy="isSubmitting" :icon="$icons.continue" :muted="!canBeSubmitted" type="submit">
      {{ $t('signupButtons.continue') }}
    </ButtonGreen>
  </div>
</template>

<script>
  import ButtonTransparent from '@/components/ButtonTransparent';
  import ButtonGreen from '@/components/ButtonGreen';

  export default {
    name: 'SignupButtons',
    components: { ButtonGreen, ButtonTransparent },
    props: {
      isSubmitting: Boolean,
      canBeSubmitted: Boolean,
    },
    computed: {
      currentStep() {
        return this.$store.state.signup.currentStep;
      },
    },
    methods: {
      goBack() {
        this.$store.dispatch('signup/goToPreviousStep');
      },
    },
  };
</script>

<style lang="scss" scoped>
  .signup-buttons {
    display: flex;
    justify-content: flex-end;
    margin-top: 15rem;

    &.has-back-button {
      justify-content: space-between;
    }
  }
</style>
